module.exports = __webpack_public_path__ + "img/sssaludconinfo.b2b72269.svg";